import { QueryClient, useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import { refetchCurrentCampaignVersion } from '@/layouts/campaigns/api/useCurrentCampaignVersionQuery'

export type Query = {
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 100
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number
}

export const useCampaignVersionsQuery = (companyId: string, gameId: string, campaignId: string, query: Query = {}) => {
  return useQuery({
    queryKey: ['campaign-versions', gameId, campaignId, query],
    queryFn: () =>
      dashboardClient.v1
        .getCampaignVersions({
          companyId,
          gameId,
          campaignId,
          ...query,
        })
        .then(r => r.data),
  })
}

export const refetchCampaignVersions = (ql: QueryClient) => {
  ql.refetchQueries({ queryKey: ['campaign-versions'], exact: false })
  refetchCurrentCampaignVersion(ql)
}
